import cn from 'classnames';

interface ILabInputListCard {
  item: IInputLists | undefined;
  active: boolean;
}

const LabInputListCard = ({item, active}: ILabInputListCard) => {

  return (
    <div
      className={cn(
        'flex flex-col justify-center items-center h-[120px] rounded-[8px] border-[1px] text-farm-shop-500 relative ',
        {'border-[2px] border-farm-shop-500 bg-farm-shop-50': active},
        {'shadow-sm': !active},
      )}
    >
      <i
        className={cn(
          'absolute top-2 right-2 text-2xl',
          {'icon-nameCheck-circle1 text-farm-shop-500': active},
          {'': !active},
        )}
      />
      {item?.image && <img src={item?.image} alt="" />}
      <span className="text-gray-950 mt-2 text-md">{item?.title}</span>
    </div>
  );
};

export default LabInputListCard;
